import { useSessionStorage } from 'usehooks-ts';
import { getPathNameWithoutPage } from '@helpers/utils/catalog/catalog-url-helpers';
import { v4 as uuidV4 } from 'uuid';

interface SearchSessionId {
  lastPlpUrl: string;
  uuid: string;
}

// we identify a single search session by its URL, which is defined as the pathname (without pagination)
// and any search queries applied
const getSearchSessionUrl = () => {
  const currentOrigin = window.location.origin;
  const currentUrl = new URL(window.location.href);
  const searchQuery = currentUrl.searchParams.get('q');

  const pathNameWithoutPage = getPathNameWithoutPage();
  const newUrl = new URL(currentOrigin + pathNameWithoutPage);

  if (searchQuery) {
    newUrl.searchParams.set('q', searchQuery);
  }

  return newUrl.toString().substring(currentOrigin.length);
};

const useSearchSessionId = () => {
  const [searchSessionId, setSearchSessionId] = useSessionStorage<SearchSessionId | null>(
    'sessionsave/searchSessionId',
    null,
  );

  const assignSearchSessionId = () => {
    const pathNameWithoutPage = getSearchSessionUrl();
    if (!searchSessionId || pathNameWithoutPage !== searchSessionId.lastPlpUrl) {
      const newSearchSessionId = {
        lastPlpUrl: pathNameWithoutPage,
        uuid: uuidV4(),
      };
      setSearchSessionId(newSearchSessionId);
      return newSearchSessionId.uuid;
    }
    return searchSessionId.uuid;
  };

  return { assignSearchSessionId };
};

export default useSearchSessionId;
